import script from "./ProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileCard.vue?vue&type=style&index=0&id=4d937a21&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d937a21"]])

export default __exports__